import { FC } from 'react';

import DialogModal from '../../../components/DialogModal/DialogModal';

interface UpdateTagConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  isDelete?: boolean;
}

export const UpdateTagConfirmationModal: FC<UpdateTagConfirmationModalProps> = ({
  isOpen,
  onCancel,
  onConfirm,
  isDelete = false
}) => {
  const title = isDelete ? 'Delete Tag' : 'Update Tag';
  const description = 'This change will apply to all content assigned to this tag.';

  return (
    <DialogModal
      isOpen={isOpen}
      title={title}
      description={description}
      modalActions={{
        onConfirm: {
          label: 'Save changes',
          action: onConfirm
        },
        onClose: {
          label: 'Cancel',
          action: onCancel,
          variant: 'ghost'
        }
      }}
    />
  );
};
